import Vue from "vue";
import Router from "vue-router";
import Home from "../page/Home.vue";
import Login from "../page/Login.vue";
import VirtualLogin from "../page/VirtualLogin.vue";
import ManagementLandingCustom from "../page/ManagementLandingCustom.vue";
import PrintDetail from '../page/PrintDetail.vue';
import PrintPreview from '@/page/printconfig/components/DragPreview.vue';
import Protocol from "../page/Protocol.vue";
import { interceptRouter } from "./intercept";
Vue.use(Router);
var router = new Router({
    routes: [
        {
            path: "/home",
            name: "Home",
            component: Home,
        },
        {
            path: "/",
            name: "Login",
            component: Login,
            meta: { noRequireAuth: true }
        },
        {
            path: "/virtuallogin",
            name: "VirtualLogin",
            component: VirtualLogin,
            meta: { noRequireAuth: true }
        },
        {
            path: "/printDetail",
            name: 'PrintDetail',
            component: PrintDetail,
            meta: { noRequireAuth: true }
        },
        {
            path: "/printPreview",
            name: 'printPreview',
            component: PrintPreview,
            meta: { noRequireAuth: true }
        },
        {
            path: "/protocol",
            name: "Protocol",
            component: Protocol,
            meta: { noRequireAuth: true }
        },
        {
            path: "/managementLandingCustom",
            name: "ManagementLandingCustom",
            component: ManagementLandingCustom,
            meta: { noRequireAuth: true }
        }
    ]
});
interceptRouter(router);
export default router;
